import { render, staticRenderFns } from "./classExam.vue?vue&type=template&id=d2d3a38c&scoped=true&"
import script from "./classExam.vue?vue&type=script&lang=js&"
export * from "./classExam.vue?vue&type=script&lang=js&"
import style0 from "./classExam.vue?vue&type=style&index=0&id=d2d3a38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d3a38c",
  null
  
)

export default component.exports